export const FRAGMENT_VERTICAL_MARGIN = 20; // in px

export const MAIN_IMAGE_HEIGHT = 500; // in px

export const MAIN_IMAGE_HEIGHT_PHONE = 420; // in px

export const FRAGMENT_MAX_WIDTH = 800;
